/*
 * Modules-page.ts
 * Description: Defining vuex module objects for storing data
 */

// Defining module to store the last page
export const moduleLastPage = {
    state: {
        last_page: '',
    },
    mutations: {
        SET_LAST_PAGE(state, data) {
            state.last_page = data;
        },
    },
    actions: {
        setLastPage({commit, state}, data) {
            commit('SET_LAST_PAGE', data);
        },
    },
    getters: {
        lastPage(state) {
            return state.last_page;
        },
    },
};

// Defining module to store the current page
export const moduleCurrentPage = {
    state: {
        current_page: 1,
    },
    mutations: {
        SET_CURRENT_PAGE(state, data) {
            state.current_page = data;
        },
    },
    actions: {
        setCurrentPage({commit, state}, data) {
            commit('SET_CURRENT_PAGE', data);
        },
    },
    getters: {
        currentPage(state) {
            return state.current_page;
        },
    },
};
